export default __webpack_public_path__ + "static/logo-c498c18736dedfc7e3486625b704b46b.png";